/**
 * Núcleo compartilhado das animações GSAP/ScrollTrigger do tema.
 * Carregado por qualquer section que precise de scroll animation
 * (ex: dbr-vitrine.js). Seguro para ser incluído mais de uma vez
 * na mesma página (múltiplas instâncias de section).
 */
(function () {
  if (window.DbrAnim) return;

  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  window.DbrAnim = {
    get reducedMotion() {
      return reduceMotionQuery.matches;
    },

    /**
     * Executa `callback(gsap, ScrollTrigger)` assim que as libs estiverem
     * disponíveis, registrando o plugin ScrollTrigger uma única vez. Como
     * scripts `defer` de sections diferentes podem executar fora da ordem
     * que a gente espera (o custom element de uma section pode fazer
     * upgrade antes do gsap-scrolltrigger.min.js de outra section
     * terminar), tenta de novo a cada frame em vez de desistir se as libs
     * ainda não estiverem prontas nesse instante exato.
     */
    ready: function (callback) {
      if (!window.gsap || !window.ScrollTrigger) {
        requestAnimationFrame(function () {
          window.DbrAnim.ready(callback);
        });
        return;
      }
      window.gsap.registerPlugin(window.ScrollTrigger);
      callback(window.gsap, window.ScrollTrigger);
    },
  };
})();
